import { render, staticRenderFns } from "./ShortageItemsFilter.vue?vue&type=template&id=230fe8d0&scoped=true&"
import script from "./ShortageItemsFilter.vue?vue&type=script&lang=js&"
export * from "./ShortageItemsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ShortageItemsFilter.vue?vue&type=style&index=0&id=230fe8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230fe8d0",
  null
  
)

export default component.exports